import {type RoomProtocolMapperClient} from '../../shared/scripts/RoomProtocolMapperClient.ts'
import {UIMSceneEnum} from '../../../shared/enums/UIMSceneEnums.ts'
import {type RoomClientState} from '../../shared/scripts/RoomClientState.ts'
import {clientI18n} from '../../shared/scripts/ClientI18n.ts'
import {LobbyImage} from '@colonist/types'
import {type UIMManager} from './ui_html/UIMManager.ts'
import {notificationController} from '../../shared/scripts/EntryShared.ts'
import {convertChatResponseToText, convertFailedToSendReasonToChatData} from '../../shared/scripts/RoomChatUtils.ts'

export function registerMobileRoomClientHandlers(roomClient: RoomProtocolMapperClient, uiManager: UIMManager) {
    roomClient.onRoomStateUpdated((roomState: RoomClientState) => {
        if(uiManager.sceneController.scene == UIMSceneEnum.Game) window.location.reload()
        uiManager.singletonPageController.closeAllPages()
        uiManager.sceneController.closeOverlays()
        uiManager.mainpageController.headerController.notificationPanelController?.hideNotificationPanel()
        uiManager.createRoomController.updateRoomState(roomState)
    })

    roomClient.onGotKicked(() => {
        notificationController.showNotification(LobbyImage.Lightning, {key: 'strings:roomPage.notifications.youWereKickedFromRoom'})
        uiManager.createRoomController.leaveRoom()
    })

    roomClient.onReceivedChatMessage((message, senderUsername, senderIcon) => {
        uiManager.createRoomController.receivedChatMessage(message, senderUsername, senderIcon)
    })

    roomClient.onFailedToSendChatMessage((reason, mutedUntil) => {
        const reasonText = convertFailedToSendReasonToChatData(reason, mutedUntil)
        const text = clientI18n.t(reasonText.key, reasonText.options)
        uiManager.createRoomController.receivedChatSystemMessage(text)
    })

    roomClient.onReceivedChatResponse((response) => {
        for(const responseText of convertChatResponseToText(response)) {
            const text = clientI18n.t(responseText.key, responseText.options)
            uiManager.createRoomController.receivedChatSystemMessage(text)
        }
    })

    roomClient.onKickedInactiveHost(() => {
        uiManager.createRoomController.onKickedInactiveHost()
    })
}
